import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { button, buttonRight, buttonOutline } from './styles.module.scss';

export const Button = ({ label, linkTo, isValid, icon, outline, ...other }) => {
  const history = useHistory();
  let classes = `${button} ${icon === 'right' ? buttonRight : ''}`;
  if (outline) {
    classes = buttonOutline;
  }
  return (
    <button
      className={classes}
      data-test={label.toLowerCase()}
      onClick={(e) => {
        e.preventDefault();
        if (isValid()) {
          history.push(linkTo);
        }
      }}
      {...other}
    >
      {label}
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.string,
  linkTo: PropTypes.string,
  isValid: PropTypes.func,
  icon: PropTypes.oneOf(['right']),
  outline: PropTypes.bool
};

Button.defaultProps = {
  isValid: () => true,
  outline: false
};
